import { apiRequest } from './api';

export const generalApi = {
  // License Types
  getLicenseTypes: async (params = {}) => {
    const queryParams = new URLSearchParams(params);
    const qs = queryParams.toString();
    return await apiRequest(`/general/license-types/${qs ? '?' + qs : ''}`);
  },

  createLicenseType: async (data) => {
    return await apiRequest('/general/license-types/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updateLicenseType: async (id, data) => {
    return await apiRequest(`/general/license-types/${id}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deleteLicenseType: async (id) => {
    return await apiRequest(`/general/license-types/${id}/`, {
      method: 'DELETE',
    });
  },

  // Licenses
  getLicenses: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const queryParams = new URLSearchParams(clean);
    const qs = queryParams.toString();
    return await apiRequest(`/general/licenses/${qs ? '?' + qs : ''}`);
  },

  getLicense: async (id) => {
    return await apiRequest(`/general/licenses/${id}/`);
  },

  createLicense: async (data) => {
    return await apiRequest('/general/licenses/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updateLicense: async (id, data) => {
    return await apiRequest(`/general/licenses/${id}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deleteLicense: async (id) => {
    return await apiRequest(`/general/licenses/${id}/`, {
      method: 'DELETE',
    });
  },

  getExpiringLicenses: async () => {
    return await apiRequest('/general/licenses/expiring/');
  },

  getDashboardStats: async () => {
    return await apiRequest('/general/licenses/dashboard-stats/');
  },

  getChartData: async () => {
    return await apiRequest('/general/licenses/chart-data/');
  },

  getLicenseReports: async (filters = {}) => {
    const queryParams = new URLSearchParams(filters);
    const qs = queryParams.toString();
    return await apiRequest(`/general/licenses/reports/${qs ? '?' + qs : ''}`);
  },

  remindLicense: async (id) => {
    return await apiRequest(`/general/licenses/${id}/remind/`, {
      method: 'POST',
    });
  },

  createQrCode: async (payload) => {
    const body = typeof payload === 'string'
      ? { target_url: payload }
      : payload;
    return await apiRequest('/general/qr-codes/', 'POST', body);
  },

  getLinkQrCodes: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const queryParams = new URLSearchParams(clean);
    const qs = queryParams.toString();
    return await apiRequest(`/general/qr-codes/${qs ? '?' + qs : ''}`);
  },

  getLinkQrCode: async (id) => {
    return await apiRequest(`/general/qr-codes/${id}/`);
  },

  updateLinkQrCode: async (id, data) => {
    return await apiRequest(`/general/qr-codes/${id}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deleteLinkQrCode: async (id) => {
    return await apiRequest(`/general/qr-codes/${id}/`, {
      method: 'DELETE',
    });
  },

  // Custom Pages (QR) — data can be a plain object (JSON) or FormData (PDF upload)
  getCustomPages: async (params = {}) => {
    const clean = Object.fromEntries(
      Object.entries(params).filter(([, v]) => v != null && v !== '')
    );
    const queryParams = new URLSearchParams(clean);
    const qs = queryParams.toString();
    return await apiRequest(`/general/custom-pages/${qs ? '?' + qs : ''}`);
  },

  getCustomPage: async (slug) => {
    return await apiRequest(`/general/custom-pages/${encodeURIComponent(slug)}/`);
  },

  createCustomPage: async (data) => {
    const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
    if (isForm) {
      return await apiRequest('/general/custom-pages/', { method: 'POST', body: data });
    }
    return await apiRequest('/general/custom-pages/', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  },

  updateCustomPage: async (slug, data) => {
    const isForm = typeof FormData !== 'undefined' && data instanceof FormData;
    if (isForm) {
      return await apiRequest(`/general/custom-pages/${encodeURIComponent(slug)}/`, {
        method: 'PUT',
        body: data,
      });
    }
    return await apiRequest(`/general/custom-pages/${encodeURIComponent(slug)}/`, {
      method: 'PUT',
      body: JSON.stringify(data),
    });
  },

  deleteCustomPage: async (slug) => {
    return await apiRequest(`/general/custom-pages/${encodeURIComponent(slug)}/`, {
      method: 'DELETE',
    });
  },
};

export default generalApi;
